/// <reference types="@yandex-int/error-counter/dist/implementation.d.ts" />

import { getChunkLoadErrorAdditional, getChunkLoadErrorMessage, parseChunkLoadError } from '../chunkLoadError';
import { getRequestContext } from '../context';
import { type ErrorBoosterLogOptions } from '../errorBooster';

export const logError = (options: ErrorBoosterLogOptions, error?: Ya.Rum.LoggableError): void => {
    // Не пишем логи для локальной разработки
    if (getRequestContext().env === 'development') {
        return;
    }

    try {
        const chunkLoadError = parseChunkLoadError(error === undefined ? options.message : error);
        let logOptions = options;

        if (chunkLoadError !== null) {
            logOptions = {
                ...options,
                message: getChunkLoadErrorMessage(chunkLoadError.chunkType),
                ignoreErrorMessage: true,
                level: 'warn',
                additional: {
                    ...options.additional,
                    ...getChunkLoadErrorAdditional(chunkLoadError),
                },
            };
        }

        window?.Ya?.Rum?.logError(logOptions, error);
    } catch {
        // Сбой логирования не должен прерывать дальнейшую работу
    }
};
